import * as types from "../types/actionTypes";
import {
  addToDepositCart,
  removeFromDepositCart,
  updateDepositQuantity,
  clearDepositCart,
  restoreDepositCartFromStorage,
} from "./utils/depositCart";

const initialState = {
  cart: restoreDepositCartFromStorage(),
  preview: null,
  loading: false,
  error: null,
  finalizeResult: null,
  lookupResult: null,
  lookupLoading: false,
  remainderFinalizeResult: null,
};

const handlers = new Map([
  [
    types.ADD_TO_DEPOSIT_CART,
    (state, action) => {
      const cart = addToDepositCart(action.ean, action.isSet, action.isAtvSet);
      return { ...state, cart, preview: null };
    },
  ],
  [
    types.REMOVE_FROM_DEPOSIT_CART,
    (state, action) => {
      const cart = removeFromDepositCart(action.ean);
      return { ...state, cart, preview: null };
    },
  ],
  [
    types.UPDATE_DEPOSIT_QUANTITY,
    (state, action) => {
      const cart = updateDepositQuantity(action.ean, action.quantity);
      return { ...state, cart, preview: null };
    },
  ],
  [
    types.CLEAR_DEPOSIT_CART,
    (state) => {
      const cart = clearDepositCart();
      return { ...state, cart, preview: null, error: null };
    },
  ],
  [
    types.DEPOSIT_PREVIEW_LOADED,
    (state, action) => ({
      ...state,
      preview: action.result,
    }),
  ],
  [
    types.DEPOSIT_CHECKOUT_LOADING,
    (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
  ],
  [
    types.DEPOSIT_CHECKOUT_ERROR,
    (state, action) => ({
      ...state,
      loading: false,
      error: action.result.reason || "Unknown error",
    }),
  ],
  [
    types.DEPOSIT_FINALIZE_RESULT,
    (state, action) => ({
      ...state,
      loading: false,
      finalizeResult: action.result,
    }),
  ],
  [
    types.DEPOSIT_LOOKUP_LOADING,
    (state) => ({
      ...state,
      lookupLoading: true,
      lookupResult: null,
    }),
  ],
  [
    types.DEPOSIT_LOOKUP_RESULT,
    (state, action) => ({
      ...state,
      lookupLoading: false,
      lookupResult: action.result,
    }),
  ],
  [
    types.DEPOSIT_REMAINDER_FINALIZE_RESULT,
    (state, action) => ({
      ...state,
      loading: false,
      remainderFinalizeResult: action.result,
    }),
  ],
]);

export default function depositReducer(state = initialState, action) {
  try {
    return handlers.has(action.type)
      ? handlers.get(action.type)(state, action)
      : state;
  } catch (err) {
    console.error("Deposit reducer error:", err);
    return state;
  }
}
